import styled from '@emotion/styled';

import { COLORS, mq } from '@clutter/clean';

import { ResponsiveImage } from '@shared/responsive_image';

export const ConversationSection = styled.section`
  padding: 0px 0 20px 0;
  background: ${COLORS.cloud};

  ${mq({
    padding: ['60px 0 76px 0', '80px 0 20px 0', '0px 0 40px 0'],
  })}
`;

export const Container = styled.div`
  width: 1050px;
  height: auto;
  min-height: 376px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 60px;

  ${mq({
    width: ['100%', '100%', '1050px'],
    minHeight: ['auto', 'auto', '376px'],
    padding: ['0 20px', '0 24px', '0 32px'],
    flexDirection: ['column', 'column', 'row'],
    gap: ['40px', '50px', '60px'],
    alignItems: ['flex-start', 'flex-start', 'center'],
  })}
`;

export const ContentWrapper = styled.div`
  display: contents;
`;

export const LeftSection = styled.div`
  flex: 1;
  max-width: 500px;

  ${mq({
    textAlign: ['left', 'left', 'left'],
    maxWidth: ['100%', '100%', '500px'],
  })}
`;

export const RightSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;

  ${mq({
    order: [-1, -1, 1],
    justifyContent: ['flex-start', 'flex-start', 'center'],
    alignSelf: ['flex-start', 'flex-start', 'auto'],
  })}
`;

export const Heading = styled.h2`
  font-family: 'Recoleta';
  font-size: 32px;
  font-weight: 500;
  color: ${COLORS.tealDark};
  line-height: 140%;
  letter-spacing: 0%;
  margin-bottom: 24px;

  ${mq({
    fontSize: ['32px', '40px', '28px'],
    marginBottom: ['16px', '20px', '24px'],
    color: ['var(--Text-Panther, #000)', COLORS.tealDark, COLORS.tealDark],
    fontFeatureSettings: ['"liga" off, "clig" off', 'normal', 'normal'],
    lineHeight: ['140%', '140%', '140%'],
    width: ['327px', 'auto', 'auto'],
    height: ['90px', 'auto', 'auto'],
  })}
`;

export const Description = styled.p`
  font-family: 'Basier Square';
  font-size: 24px;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0%;
  margin-bottom: 32px;

  ${mq({
    fontSize: ['18px', '17px', '24px'],
    marginBottom: ['24px', '28px', '32px'],
    color: ['var(--Text-Panther, #000)', 'inherit', 'inherit'],
    fontStyle: ['normal', 'inherit', 'inherit'],
  })}
`;

export const LearnMoreButton = styled.a`
  background: ${COLORS.tealPrimary};
  color: ${COLORS.cloud};
  border: none;
  border-radius: 24px;
  padding: 16px 32px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;

  &:hover {
    background: ${COLORS.tealJungle};
    transform: translateY(-1px);
    box-shadow: 0 4px 16px rgba(9, 126, 119, 0.3);
  }

  ${mq({
    display: ['flex', 'inline-block', 'inline-block'],
    padding: ['var(--S, 18px) 43px', '14px 28px', '16px 32px'],
    alignItems: ['center', 'initial', 'initial'],
    gap: ['10px', '0', '0'],
    borderRadius: ['var(--L, 36px)', '24px', '24px'],
    background: [
      'var(--Primary-Teal, #097E77)',
      COLORS.tealPrimary,
      COLORS.tealPrimary,
    ],
    color: ['var(--Text-Cloud, #FFF)', COLORS.cloud, COLORS.cloud],
    textAlign: ['center', 'initial', 'initial'],
    fontFeatureSettings: ['"liga" off, "clig" off', 'normal', 'normal'],
    fontFamily: ['"Basier Square"', '"Basier Square"', '"Basier Square"'],
    fontSize: ['17px', '15px', '16px'],
    fontStyle: ['normal', 'normal', 'normal'],
    fontWeight: ['600', '600', '600'],
    lineHeight: ['normal', 'normal', 'normal'],
    width: ['177px', 'auto', 'auto'],
    height: ['57px', 'auto', 'auto'],
  })}
`;

export const ImageContainer = styled.div`
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;

  ${mq({
    height: ['327px', 'auto', 'auto'],
    alignSelf: ['stretch', 'auto', 'auto'],
    borderRadius: ['var(--S, 18px)', '14px', '16px'],
    maxWidth: ['none', '400px', '500px'],
  })}
`;

export const ConversationImage = styled(ResponsiveImage)`
  width: 100%;
  display: block;

  ${mq({
    height: ['100%', 'auto', 'auto'],
    objectFit: ['cover', 'initial', 'initial'],
  })}
`;
